import React from 'react';
import TopicCard from '../components/TopicCard/TopicCard';
import styles from './Pages.module.css';

const MapsPage: React.FC = () => {
 return (
    <div className={styles.container}>
      <h1 className={styles.title}>Maps & Caches</h1>
      <p className={styles.subtitle}></p>
      <div className={styles.cardContainer}>
        <TopicCard
          title='Hash Map'
          description='A fast key-value store that uses hashing to achieve O(1) average lookups.'
          link ='/map/hashmap'
          icon='⚡️'
          />
        <TopicCard
          title='Least Recently Used'
          description='A cache that removes the item that hasn’t been used for the longest time.'
          link ='/map/lru'
          icon='🔺'
          />
        <TopicCard
          title='Least Frequently Used'
          description='A cache that evicts the item with the fewest accesses over time.'
          link ='/map/lfu'
          icon='🔤'
          />
          <TopicCard
          title='Compare Caches'
          description='See how LRU and LFU differ in performance, eviction strategy, and behavior.'
          link ='/map/comparecache'
          icon='⚖️'
          />
      </div>
    </div>
  );
};

export default MapsPage;